__turbopack_context__.v({
  "caption": "_8PjxuG_caption",
  "content": "_8PjxuG_content",
  "countdown": "_8PjxuG_countdown",
  "countdownWrapper": "_8PjxuG_countdownWrapper",
  "dropDateCopy": "_8PjxuG_dropDateCopy",
  "headingWithIcon": "_8PjxuG_headingWithIcon",
  "headingWrapper": "_8PjxuG_headingWrapper",
  "remindMeButton": "_8PjxuG_remindMeButton",
  "remindMeButtonWrapper": "_8PjxuG_remindMeButtonWrapper",
  "reminderSetLabel": "_8PjxuG_reminderSetLabel",
  "signupButton": "_8PjxuG_signupButton",
  "signupButtonWrapper": "_8PjxuG_signupButtonWrapper",
  "wrapper": "_8PjxuG_wrapper",
});
